let swr: any = {};
try {
  swr = require('swr').default;
} catch (err) {}

export default swr;
